/**
 * Formats a payment date string as "MMM DD, YYYY" (e.g. "Jan 05, 2024").
 *
 * Accepts ISO 8601 'YYYY-MM-DD' date-only strings and appends 'T00:00:00'
 * before parsing to avoid timezone-offset causing an off-by-one day.
 */
export function formatPaymentDate(dateStr: string): string {
  const normalized = dateStr.includes('T') ? dateStr : `${dateStr}T00:00:00`;
  return new Date(normalized).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
}
